export const locale = {
    lang: 'en',
    data: {
        'QUEUE': {
            'LEAD': 'Lead',
            'WARN_MSG': ' You have not yet processed the current lead!',
            'GET_NEXT': 'Get next lead',
            'STOP': 'Stop',
            'WAITIN_MSG': 'Waiting new lead'
        }
    }
};



// WEBPACK FOOTER //
// ./src/app/main/lead-queue-pannel/i18n/en.ts